export const PERMISSION_MODAL_TOOLTIP =
  "Permissions allow a company to control its users' access levels to the module and its fields depending on their roles and functions. Users can have multiple levels of access such as creating and editing a module, to read-only or none at all.";

export const PERMISSION_SEARCH_PLACEHOLDER = 'Search Module & Field Level Permissions';

export const BULK_MODAL_TOOLTIP =
  'Select the rows you want to update, then configure the permissions for those rows.';

export const getPermissionModalTitle = (
  modalStatus: string,
  entityType: 'role' | 'featureSet',
  entityName?: string
): string => {
  const typeLabel = entityType === 'role' ? 'System Role' : 'Feature Set';

  if (modalStatus === 'View' && entityName) {
    return entityName;
  }

  return `${modalStatus} ${typeLabel}`;
};

export const getBulkEditTitle = (permissionType: 'roles' | 'feature-set'): string => {
  return permissionType === 'roles' ? 'Bulk Edit Roles' : 'Bulk Edit Feature Sets';
};

export const getBulkEditUrlName = (permissionType: 'roles' | 'feature-set'): string => {
  return permissionType === 'roles' ? 'roles' : 'feature-set';
};
